import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import { ReactComponent as FavouriteSolid } from "../Icons/FavouriteSolid.svg";
import { ReactComponent as FavouriteOutline } from "../Icons/star.svg";
import { ReactComponent as MinimizeIcon } from "../Icons/minimize.svg";
import { ReactComponent as MaximizeIcon } from "../Icons/maximize.svg";
import { readFavoriteTools } from "../Services/toolFavorites";
import { getCanonicalToolName } from "../HomePage/toolRoutes";

function ToolHeader({
    title,
    description,
    toolFav,
    showFavourite = Boolean(toolFav),
    showExpand = true,
    className = ""
}) {
    const { toggleSidebar, collapsed } = useOutletContext() || {};
    const [isFavourite, setIsFavourite] = useState(false);
    const [showFavTooltip, setShowFavTooltip] = useState(false);
    const [showExpandTooltip, setShowExpandTooltip] = useState(false);

    useEffect(() => {
        if (!toolFav?.toolName) return;

        const saved = readFavoriteTools();
        setIsFavourite(saved.some((tool) => tool.toolName === getCanonicalToolName(toolFav.toolName)));
    }, [toolFav]);

    const toggleFavourite = () => {
        if (!toolFav?.toolName) return;

        const saved = readFavoriteTools();
        const toolName = getCanonicalToolName(toolFav.toolName);
        const nextSaved = isFavourite
            ? saved.filter((tool) => tool.toolName !== toolName)
            : [...saved, { ...toolFav, toolName }];

        localStorage.setItem("favoriteTools", JSON.stringify(nextSaved));
        setIsFavourite(!isFavourite);
    };

    return (
        <Row className={`Introduction-Header${className ? ` ${className}` : ""}`}>
            <Col md={6}>
                <div className="Introduction">
                    <span className="Heading">{title}</span>
                    {description && <p className="Paragrapgh">{description}</p>}
                </div>
            </Col>
            {(showFavourite || showExpand) && (
                <Col md={6}>
                    <div className="Intro-buttons">
                        {showFavourite && (
                            <div
                                className="FavTooltipWrapper"
                                onMouseEnter={() => setShowFavTooltip(true)}
                                onMouseLeave={() => setShowFavTooltip(false)}
                                style={{ position: "relative", display: "inline-flex" }}
                            >
                                {isFavourite ? (
                                    <FavouriteSolid className="FavIcon" onClick={toggleFavourite} />
                                ) : (
                                    <FavouriteOutline className="FavIcon" onClick={toggleFavourite} />
                                )}
                                {showFavTooltip && (
                                    <div className="FavTooltip">
                                        {isFavourite ? "Remove from favourites" : "Add to favourites"}
                                    </div>
                                )}
                            </div>
                        )}
                        {showExpand && (
                            <div
                                className="FavTooltipWrapper"
                                onMouseEnter={() => setShowExpandTooltip(true)}
                                onMouseLeave={() => setShowExpandTooltip(false)}
                                style={{ position: "relative", display: "inline-flex" }}
                            >
                                {collapsed ? (
                                    <MinimizeIcon className="FavIcon" onClick={toggleSidebar} />
                                ) : (
                                    <MaximizeIcon className="FavIcon" onClick={toggleSidebar} />
                                )}
                                {showExpandTooltip && (
                                    <div className="FavTooltip">{collapsed ? "Minimize" : "Maximize"}</div>
                                )}
                            </div>
                        )}
                    </div>
                </Col>
            )}
        </Row>
    );
}

export default ToolHeader;
